/* vendors */
import svgxuse from 'svgxuse'; // eslint-disable-line no-unused-vars
import picturefill from 'picturefill'; // eslint-disable-line no-unused-vars

/* modules */
import Accordion from './modules/accordion';
import Slider from './modules/slider';
import marketingSlider from './modules/marketingSlider';
import Nav from './modules/nav';
import TableScroll from './modules/table-scroll';
/* styles */
import style from '../scss/main.scss'; // eslint-disable-line no-unused-vars

new Accordion(); // eslint-disable-line no-new
new Nav(); // eslint-disable-line no-new
new TableScroll(); // eslint-disable-line no-new
Slider(); // eslint-disable-line no-new
marketingSlider(); // eslint-disable-line no-new
